import axios from 'axios';
import { GET_FUTURE_ORDERS_COUNT } from './types';
import { API_URL } from '../../constants'

export const getFutureOrdersCount = () => dispatch => {
    axios
        .get(API_URL + 'get-future-orders-count')
        .then(res => {
            return dispatch({
                type: GET_FUTURE_ORDERS_COUNT,
                payload: res.data
            })
        }

        ).catch(error => {
            throw (error);
        });
}
